module.exports = __webpack_public_path__ + "img/logo_6.342c0f74.png";